import type * as React from 'react';
import type { FC } from 'react';

import ChevronDown from '@crehana/icons/fill/ChevronDown';
import useCollapse from '@crehana/react-hooks/dist/useCollapse';
import unescapeChars from '@crehana/ui/dist/StringParser/utils/unescapeChars';
import { primaryMain } from '@crehana/ui/dist/styles/colors';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled, { css } from 'styled-components';

type ItemProps = {
  item: {
    id: number;
    question: string;
    answer: string;
  };
};

const ArrowWrapper = styled.div<{ isOpen: boolean }>`
  will-change: transform;
  transition: 0.3s;
  transform: rotate(${props => (props.isOpen ? '-180deg' : '0deg')});
`;

const Item: FC<React.PropsWithChildren<ItemProps>> = ({ item }) => {
  const { getToggleProps, getCollapseProps, isOpen } = useCollapse();

  return (
    <li className="bg-gray-lighter mb-16 sm:mb-16 rounded-5">
      <button
        className="w-full py-16 px-12 flex items-center outline-none focus:outline-none sm:p-24 md:px-32"
        type="button"
        css={css`
          -webkit-tap-highlight-color: transparent;
        `}
        {...getToggleProps()}
      >
        {/* Title */}
        <div className="mr-auto">
          <p className="font-subtitle1-md text-left ">{item.question}</p>
        </div>
        <div className="ml-24 sm:ml-16 flex-shrink-0">
          <ArrowWrapper isOpen={isOpen}>
            <ChevronDown size={24} color={primaryMain} />
          </ArrowWrapper>
        </div>
      </button>
      <div {...getCollapseProps()}>
        {/* Answer */}
        <div className="pb-24 px-12 sm:px-24 md:px-32">
          <p
            className="font-body1-md "
            dangerouslySetInnerHTML={{ __html: unescapeChars(item.answer) }}
          />
        </div>
      </div>
    </li>
  );
};

export default Item;
